export const Testimonials = [
  {
    rating: 5,
    customerName: "Mahin Moh",
    testimonial:
      "Vi er kjempefornøyde med jobben Grønvold Byggservice AS gjorde hos oss. De pusset opp både stuen og kjøkkenet vårt, og resultatet ble helt fantastisk. Alle som var involvert, snekkere, rørlegger, elektriker og maler, var utrolig dyktige, profesjonelle og hyggelige. Arbeidet ble gjort til avtalt tid og pris, og kommunikasjonen underveis var topp. Kan virkelig anbefale Grønvold Byggservice AS til alle som ønsker kvalitet og pålitelig håndverk. Tusen takk for en strålende jobb!",
  },
  {
    rating: 5,
    customerName: "Merete Jensen",
    testimonial:
      "Veldig fornøyd med tjenesten levert av Andreas ved Grønvold bygg. Fin dialog før underveis og etterpå. Tok seg tid og leverte på kort varsel. Hensyn til huset forøvrig. Flink til å beskytte gulv m.m Forsto godt hva jeg ønsket og leverte akkurat slik jeg ba om. Bygge lett vegger, kle igjen vegg, lage ramme og kle igjen rundt skap under trapp. Resultatet upåklagelig. Nøye. Anbefales uten tvil.",
  },
  {
    rating: 5,
    customerName: "Kjersti Thea Strømnes",
    testimonial:
      "Andreas Grønvold har blant revet eksisterende tak innendørs og lagt panel hos oss. En tillitvekkende, serviceinnstilt og hyggelig håndtverker. Nøyaktig og pent utført arbeid og en mann det er enkelt å kommunisere med. Det er veldig lett å anbefale ham videre og det er absolutt ikke siste gang jeg spør ham om hjelp!",
  },
  {
    rating: 5,
    customerName: "Magnus Fagerli",
    testimonial:
      "Andreas har har hjulpet oss med mange prosjekter allerede. Skiftet alle dører innvendig, og listet rundt om i hele huset. Nøye og effektiv!",
  },
];
